import { render, staticRenderFns } from "./BookInfoModal.vue?vue&type=template&id=3824b55b&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./BookInfoModal.vue?vue&type=script&lang=js&"
export * from "./BookInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./BookInfoModal.vue?vue&type=style&index=0&id=3824b55b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3824b55b",
  null
  
)

component.options.__file = "BookInfoModal.vue"
export default component.exports